import { render, staticRenderFns } from "./stacksList.vue?vue&type=template&id=022df73d&scoped=true&"
import script from "./stacksList.vue?vue&type=script&lang=ts&"
export * from "./stacksList.vue?vue&type=script&lang=ts&"
import style0 from "./stacksList.vue?vue&type=style&index=0&id=022df73d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022df73d",
  null
  
)

export default component.exports